import { render } from "./HistoryLeave.vue?vue&type=template&id=5ffc4a2b&scoped=true"
import script from "./HistoryLeave.vue?vue&type=script&lang=js"
export * from "./HistoryLeave.vue?vue&type=script&lang=js"

import "./HistoryLeave.vue?vue&type=style&index=0&id=5ffc4a2b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffc4a2b"]])

export default __exports__